import styled from 'styled-components'

export const Container = styled.div`
  .imgLine {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-top:.6rem;

    img {
      max-width: 125px;
      border-radius: 50%;
    }
    @media (max-width: 983px) {
      img {
        max-width: 115px;
      }
    }

    @media (max-width: 397px) {
      img {
        display: none;
      }
    }
  }

  .imgsGroup {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .titleGroup {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.25rem;
  }

  .descricaoGroup {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }
`

export const Title = styled.div`
  font-size: 4rem;
  font-weight: 900;
  color: var(--purple);
  @media (max-width: 655px) {
    font-size: 3rem;
  }
`

export const SubTitle = styled.div`
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--orange);
  @media (max-width: 655px) {
    font-size: 1.2rem;
  }
`

export const LocalidadesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  margin-top: 0.75rem;

  .estado-row {
    display: flex;
    align-items: baseline;
    gap: 1rem;
    padding: 0.4rem 0.6rem;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 0.2s ease;

    strong {
      font-size: 1.1rem;
      font-weight: 800;
      color: var(--purple);
      min-width: 28px;
      transition: color 0.2s ease;
    }

    span {
      font-size: 1.05rem;
      font-weight: 500;
      color: var(--black);
      transition: color 0.2s ease;
    }

    &:hover,
    &.ativo {
      background-color: rgba(114, 65, 161, 0.12);

      strong {
        color: #5a2d85;
      }

      span {
        color: var(--purple);
      }
    }
  }

  @media (max-width: 655px) {
    .estado-row {
      padding: 0.3rem 0.4rem;
      strong { font-size: 1rem; }
      span { font-size: 0.95rem; }
    }
  }
`

export const CtaExpansao = styled.button`
  background: none;
  border: 2px dashed var(--purple);
  border-radius: 8px;
  color: var(--purple);
  font-size: 1rem;
  font-weight: 600;
  padding: 0.7rem 1.2rem;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  width: fit-content;

  &:hover {
    background-color: var(--purple);
    color: white;
    border-style: solid;
  }

  @media (max-width: 655px) {
    font-size: 0.9rem;
    padding: 0.6rem 1rem;
  }
`

export const ElementVantagens = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 85vh;

  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;

  @media (max-width: 983px) {
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: column-reverse;
    gap: 2rem;
    text-align: center;

    .descricaoGroup {
      align-items: center;
    }
  }

  @media (min-width: 768px) {
    width: 750px;
  }

  @media (min-width: 992px) {
    width: 970px;
  }

  @media (min-width: 1200px) {
    width: 1170px;
  }
`

export const ElementVantagensWhite = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 85vh;
  background-color: var(--background);

  @media (max-width: 983px) {
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: column-reverse;
    gap: 5rem;
  }

  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;

  @media (min-width: 768px) {
    width: 750px;
  }

  @media (min-width: 992px) {
    width: 970px;
  }

  @media (min-width: 1200px) {
    width: 1170px;
  }
`

export const TitleGroupLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
`

export const ImgMapa = styled.img`
  max-width: 300px;
`

export const BackgroundPurple = styled.div`
  background-color: var(--background);
`

export const ModalidadesSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5rem 15px;
  margin-right: auto;
  margin-left: auto;

  @media (min-width: 768px) {
    width: 750px;
  }
  @media (min-width: 992px) {
    width: 970px;
  }
  @media (min-width: 1200px) {
    width: 1170px;
  }
`

export const ModalidadesCards = styled.div`
  display: flex;
  gap: 2rem;
  margin-top: 2.5rem;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1.5rem;
  }
`

export const ModalidadeCard = styled.div`
  flex: 1;
  border-radius: 16px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  ${({ $destaque }) =>
    $destaque
      ? `
    background: linear-gradient(135deg, var(--purple), #5a2d85);
    color: white;
    box-shadow: 0 8px 32px rgba(114, 65, 161, 0.3);

    h3 { color: white; }
    .badge { background: var(--orange); color: white; }
    .features li::before { color: var(--orange); }
  `
      : `
    background: white;
    border: 2px solid var(--purple);
    color: var(--black);

    h3 { color: var(--purple); }
    .badge { background: rgba(114, 65, 161, 0.1); color: var(--purple); }
    .features li::before { color: var(--purple); }
  `}

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 40px rgba(114, 65, 161, 0.25);
  }

  .badge {
    font-size: 0.8rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    padding: 0.3rem 0.8rem;
    border-radius: 20px;
    width: fit-content;
  }

  h3 {
    font-size: 1.6rem;
    font-weight: 800;
    margin: 0;
  }

  .descricao {
    font-size: 1.05rem;
    line-height: 1.6;
    opacity: 0.9;
  }

  .features {
    list-style: none;
    padding: 0;
    margin: 0.5rem 0 0 0;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    li {
      font-size: 0.95rem;
      display: flex;
      align-items: center;
      gap: 0.5rem;

      &::before {
        content: '\\2713';
        font-weight: 700;
        font-size: 1.1rem;
      }
    }
  }
`

export const LocalidadesBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(114, 65, 161, 0.12);
  color: var(--purple);
  font-size: 0.85rem;
  font-weight: 700;
  padding: 0.4rem 1rem;
  border-radius: 20px;
  margin-top: 0.5rem;
  width: fit-content;

  .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--orange);
  }
`

export const BannerBrasil = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  background: linear-gradient(135deg, rgba(114, 65, 161, 0.08), rgba(114, 65, 161, 0.15));
  border: 1px solid rgba(114, 65, 161, 0.2);
  border-radius: 12px;
  padding: 1rem 1.5rem;
  margin-top: 1.5rem;
  width: fit-content;

  .icon-brasil {
    font-size: 1.8rem;
    line-height: 1;
  }

  .texto {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;

    strong {
      font-size: 1rem;
      color: var(--purple);
    }

    span {
      font-size: 0.85rem;
      color: var(--black);
      opacity: 0.75;
    }
  }

  @media (max-width: 655px) {
    padding: 0.8rem 1rem;

    .icon-brasil { font-size: 1.4rem; }
    .texto strong { font-size: 0.9rem; }
    .texto span { font-size: 0.8rem; }
  }
`
